import { z } from "zod";
import { DbtCloudValidationResponse } from "../../../types";

export const connectionSchema = z.object({
  account_id: z.string().min(1, "Account ID is required"),
  api_token: z.string().min(1, "Service Account Token is required"),
  api_base_url: z
    .string()
    .url("Must be a valid URL")
    .optional()
    .or(z.literal(""))
    .default("https://cloud.getdbt.com/api/v2/"),
});

export type ConnectionFormValues = z.infer<typeof connectionSchema>;

export interface DbtCloudConnectionData {
  account_id: string;
  api_token: string;
  api_base_url: string;
  validationResult: DbtCloudValidationResponse | null;
}

export const DEFAULT_API_BASE_URL = "https://cloud.getdbt.com/api/v2/";
